import get from 'lodash/get';
import isArray from 'lodash/isArray';
import isPlainObject from 'lodash/isPlainObject';
import mapValues from 'lodash/mapValues';
import { requiredArg } from './args';

export const resolveRefs = (obj, validate = requiredArg('validate')) => {
  const { refs } = validate.schemaEnv;

  if (isPlainObject(obj)) {
    const ref = obj.$ref ? refs[obj.$ref] : null;

    if (typeof ref === 'undefined') {
      throw new Error(`Ref ${obj.$ref} does not exist.`);
    }

    return mapValues(ref ? { ...obj, ...(ref.schema || ref) } : obj, v =>
      resolveRefs(v, { schemaEnv: { refs } })
    );
  }

  if (isArray(obj)) {
    return obj.map(item => resolveRefs(item, { schemaEnv: { refs } }));
  }

  return obj;
};

export const resolveTranslationRefs = (obj, translations) => {
  if (isPlainObject(obj) && obj.$ref) {
    const match = obj.$ref.match(/#\/(.+)/);

    if (match) {
      const path = match[1].split('/');

      return get(translations, path, {});
    }

    return {};
  }

  return obj;
};
